// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rCbA","col":"styles_col__241kD"};